import PropTypes from 'prop-types';
import React from 'react';
import FieldsWrapper, { defaultFields } from '../FieldsWrapper/FieldsWrapper';
import { appendEnforceMinTokens, enforceMinTokensField } from '../LimitBuy/LimitBuy';

const fields = (fieldsState) => [
  ...defaultFields({
    ...fieldsState,
    label: 'common.sale_amount_src',
    infoHint: 'Select the amount of tokens you wish to sell',
  }),
  enforceMinTokensField({
    textFieldProps: { renderValue: (value) => `$${value}` },
    infoHint:
      'The minimum value in USD added to the pool after the trade is executed. The pool will receive this amount in WBNB',
  }),
];
export default function StopLoss({ type }) {
  return (
    <FieldsWrapper
      initialValues={{ slippage: 2.5 }}
      onValuesChanges={appendEnforceMinTokens}
      fields={fields}
      type={type}
      submitText="hpool.trade_orders_stop_loss"
    />
  );
}

StopLoss.propTypes = {
  type: PropTypes.string.isRequired,
};
